import { Grid } from '@mui/material';
import styled from 'styled-components';

export const FullHeightGrid = styled(Grid)`
  height: 100%;
  width: 100%;
`;

export const GridCard = styled(Grid)`
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
`;
